import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-334f5fbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-auto" }
const _hoisted_2 = { class: "row overflow-hidden" }
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "primary w-full absolute z-10 cursor-pointer opacity-0 h-16 left-0 top-1 bg-white",
  id: "chck3",
  type: "checkbox"
}, null, -1))
const _hoisted_6 = {
  class: "flex justify-between items-center cursor-pointer select-none tab-label bg-white rounded-lg",
  for: "chck3"
}
const _hoisted_7 = { class: "elements grid grid-cols-4 w-full pt-1 pb-1 text-left self-center bg-primary-50 items-center" }
const _hoisted_8 = {
  key: 0,
  class: "font-bold"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "animate-pulse bg-primary-100 w-60"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 1,
  class: "font-bold"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "animate-pulse bg-primary-100 w-60"
}
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 0,
  class: "clocking-in-date"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "animate-pulse bg-primary-100 w-60"
}
const _hoisted_19 = { key: 2 }
const _hoisted_20 = {
  key: 2,
  class: "dropdown-section flex test m-auto bg-white rounded p-2"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-bold" }, "Vedi dettagli", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  "data-reactid": "266",
  fill: "none",
  height: "24",
  stroke: "#606F7B",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewbox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "6 9 12 15 18 9" })
], -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "tab-content mt-2" }
const _hoisted_25 = { class: "relative pl-5 pb-2" }
const _hoisted_26 = {
  key: 0,
  class: "note"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-left font-bold" }, "Note:", -1))
const _hoisted_28 = { class: "text-grey-darkest text-left notes pt-2" }
const _hoisted_29 = {
  key: 1,
  class: "pb-2"
}
const _hoisted_30 = {
  key: 2,
  class: "expense text-left font-bold pt-2"
}
const _hoisted_31 = { class: "text-grey-darkest text-left notes pl-2" }
const _hoisted_32 = {
  key: 3,
  class: "no-expense pb-2"
}
const _hoisted_33 = {
  key: 4,
  class: "attachment text-left"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pt-4 text-left font-bold" }, "Allegati:", -1))
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "icon m-auto" }
const _hoisted_37 = {
  key: 5,
  class: "pb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BlueDocumentIcon = _resolveComponent("BlueDocumentIcon")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("header", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.scope == _ctx.UserExpenseScope.workingSite)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_8, [
                    (_ctx.modelValue.userId != undefined && _ctx.userName != '')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.userName), 1))
                      : (_ctx.modelValue.userId != undefined)
                        ? (_openBlock(), _createElementBlock("input", _hoisted_10))
                        : (_openBlock(), _createElementBlock("span", _hoisted_11, "Non specificato"))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.scope == _ctx.UserExpenseScope.user)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_12, [
                    (_ctx.modelValue.workingSiteId != undefined && _ctx.workingSiteName != '')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.workingSiteName), 1))
                      : (_ctx.modelValue.workingSiteId != undefined)
                        ? (_openBlock(), _createElementBlock("input", _hoisted_14))
                        : (_openBlock(), _createElementBlock("span", _hoisted_15, "Non specificato"))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("h3", null, [
                (_ctx.modelValue.createdTs)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.moment.unix(_ctx.modelValue.createdTs).format("DD/MM/YYYY HH:mm")), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("h3", null, [
                (_ctx.modelValue.toolId != undefined && _ctx.toolName != '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.toolName), 1))
                  : (_ctx.modelValue.toolId != undefined)
                    ? (_openBlock(), _createElementBlock("input", _hoisted_18))
                    : (_openBlock(), _createElementBlock("span", _hoisted_19, "Non specificata"))
              ]),
              ((_ctx.modelValue.notes && _ctx.modelValue.notes.length > 0) || _ctx.modelValue.totalExpense || (_ctx.modelValue.pictureUrls && _ctx.modelValue.pictureUrls.length > 0))
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              (_ctx.modelValue.notes && _ctx.modelValue.notes.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.modelValue.notes), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_29)),
              (_ctx.modelValue.totalExpense)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createTextVNode("Spese totali:"),
                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.modelValue.totalExpense), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_32)),
              (_ctx.modelValue.pictureUrls && _ctx.modelValue.pictureUrls.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _hoisted_34,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue.pictureUrls, (attachment) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "document bg-primary-50 rounded-lg m-auto cursor-pointer border-solid border-2 hover:border-primary-100",
                        onClick: ($event: any) => (_ctx.onAttachmentClick(attachment))
                      }, [
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_BlueDocumentIcon, { "mime-type-slag": "IMG" })
                        ])
                      ], 8, _hoisted_35))
                    }), 256))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_37))
            ])
          ])
        ])
      ])
    ])
  ]))
}